import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const IMAGE_STRENGTH_DEFAULT = 10 // yPercent — voir la marge (30%) prévue dans _parallax.scss
const IMAGE_STRENGTH_MAX = 18
const BG_STRENGTH_DEFAULT = 18    // points de % autour du centre (50%)

const reduceMotion = typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export function observe (el) {

  if (!el || !el.dataset || !('parallax' in el.dataset)) return
  if (reduceMotion) return
  if (el.dataset.parallaxReady) return
  el.dataset.parallaxReady = '1'

  if (el.tagName === 'IMG') initImage(el)
  else initBackground(el)

}

export function render () {
  document.querySelectorAll('[data-parallax]').forEach(observe)
}

function readStrength (el, fallback, max) {
  const value = parseFloat(el.dataset.parallax)
  if (!Number.isFinite(value)) return fallback
  return max ? gsap.utils.clamp(-max, max, value) : value
}

function initImage (img) {

  const wrapper = img.parentElement
  if (!wrapper) return

  const strength = readStrength(img, IMAGE_STRENGTH_DEFAULT, IMAGE_STRENGTH_MAX)

  gsap.fromTo(img,
    { yPercent: -strength },
    {
      yPercent: strength,
      ease: 'none',
      scrollTrigger: {
        trigger: wrapper,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    }
  )

}

function initBackground (el) {

  const strength = readStrength(el, BG_STRENGTH_DEFAULT)

  gsap.fromTo(el,
    { backgroundPositionY: `${50 - strength}%` },
    {
      backgroundPositionY: `${50 + strength}%`,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    }
  )

}
